'use client';

import { Button } from '@packages/shared/src/ui/Button/Button';
import { Dialog } from '@packages/shared/src/ui/Dialog/Dialog';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';
import { DialogHeader } from '@packages/modules/src/Dialog/DialogHeader/DialogHeader.client';
import { rewriteCmsImageUrls } from '@packages/shared/src/utils/rewriteCmsImageUrls/rewriteCmsImageUrls';
import { useState } from 'react';
import reactStringReplace from 'react-string-replace';
import { SoftHyphenInjector } from '../SoftHyphenInjector';
import type { ModalType } from '../../../interfaces/components';

type ComponentProps = {
  /** replace placeholders within a string. Example: "Prices incl. VAT and plus [[TextLink]]." */
  replaceText: string;
  /** data object */
  data: ModalType;
};

/** Composite dialog component with title and content that is initialized by the Component "ModalByTextlink". Based on Shared Dialog: @packages/shared/Dialog */
export const ModalChild = ({ replaceText, data }: ComponentProps) => {
  const {
    field_placeholder_id: placeholderId,
    field_placeholder_text: placeholderText,
    field_headline: headline = '',
    field_html_editor: modalContent = '',
  } = data;

  // init state
  const [stateOpen, setStateOpen] = useState<boolean>(false);

  // handle open/close
  const handleOpen = () => setStateOpen(true);
  const handleClose = () => setStateOpen(false);

  return (
    <div>
      {reactStringReplace(rewriteCmsImageUrls(replaceText), placeholderId, (_, index) => (
        <div key={`${placeholderId}_${index}`} className="inline-block">
          <Button
            variant="textLink"
            onClick={(event) => {
              event.preventDefault();
              handleOpen();
            }}
          >
            <SoftHyphenInjector text={placeholderText} />
          </Button>
          <Dialog isOpen={stateOpen} onClose={handleClose}>
            <DialogHeader onClose={handleClose}>{headline}</DialogHeader>
            <DialogContent
              className="text-size-body-sm max-h-[85vh] overflow-y-auto p-2"
              dangerouslySetInnerHTML={{ __html: rewriteCmsImageUrls(modalContent) }}
            />
          </Dialog>
        </div>
      )).map((chunk, index) =>
        // iterate over the returned array and render the chunks (that stayed a string) as html
        typeof chunk === 'string' ? (
          <span
            // eslint-disable-next-line @eslint-react/no-array-index-key
            key={`chunk_${index}`}
            dangerouslySetInnerHTML={{ __html: chunk }}
          />
        ) : (
          chunk
        ),
      )}
    </div>
  );
};
